import React, { useEffect, useState } from 'react';
import classNames from "classnames";


interface ToggleProps {
    disabled?: boolean;
    defaultStatus?: boolean;
    onToggle: (isToggle: boolean) => void;
}

const Toggle: React.FC<ToggleProps> = (props) => {
    const { defaultStatus = false, disabled = false, onToggle } = props;
    const [enabled, setEnabled] = useState<boolean>(defaultStatus);

    const onChange = (checked: boolean) => {
        if (disabled) {
            return;
        }
        onToggle(checked);
        setEnabled(checked);
    };
    
    useEffect(() => {
        setEnabled(defaultStatus);
    }, [defaultStatus]);

    return (
        <button aria-pressed={enabled ?? false}
                disabled={disabled}
                className="h-4.5 w-8"
                onClick={() => onChange(!enabled)}
        >
            <svg width={30} height={18} viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width={30} height={18} rx={9}
                      className={classNames(
                          "transition-colors",
                          (enabled && !disabled) ? "fill-chat42" : "fill-black-300"
                      )}
                />

                <circle cx={7.5}
                        cy={8.9}
                        r={7.5}
                        fill="white"
                        className={classNames(
                            "transition-transform",
                            enabled ? "translate-x-[calc(100%-2px)]" : "translate-x-[2px]",
                        )}
                        style={{ transformBox: "fill-box" }}
                />
            </svg>
        </button>
    );
};

export default Toggle;